// axios
import axios from 'axios';
// routes
import {routes} from "../../../features/routes/route";
// config
import {AuthConfig} from "../../../config/authConfig";

export const matchCart = async (data: any) => {
    const {data: response} = await axios.post(`${routes.api[0].address}MerchantRegister/MatchIbanByNationalCode`, data, AuthConfig);
    return response;
};
